/**
 * @generated SignedSource<<1fd64c56e0dfee3c8f8e24690c5a1d60>>
 * @relayHash 90bbdfd066c472a82dcb4c9e40e7e214
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f9d6b64831195378ddcecd6fc95c30ab8b99f0ad3ef256010f57edf3842a8c1a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GetTemplateBodyContentQuery$variables = {
  templateId: string;
};
export type GetTemplateBodyContentQuery$data = {
  readonly template: {
    readonly body: {
      readonly atlas_doc_format: {
        readonly value: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly editorVersion: string | null | undefined;
    readonly name: string | null | undefined;
    readonly templateId: string | null | undefined;
  } | null | undefined;
};
export type GetTemplateBodyContentQuery = {
  response: GetTemplateBodyContentQuery$data;
  variables: GetTemplateBodyContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "alias": "template",
    "args": [
      {
        "kind": "Variable",
        "name": "contentTemplateId",
        "variableName": "templateId"
      }
    ],
    "concreteType": "ContentTemplate",
    "kind": "LinkedField",
    "name": "confluence_template",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "templateId"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "editorVersion"
      },
      {
        "concreteType": "EnrichableMap_ContentRepresentation_ContentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "atlas_doc_format",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GetTemplateBodyContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetTemplateBodyContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "90bbdfd066c472a82dcb4c9e40e7e214",
    "id": "f9d6b64831195378ddcecd6fc95c30ab8b99f0ad3ef256010f57edf3842a8c1a",
    "metadata": {},
    "name": "GetTemplateBodyContentQuery",
    "operationKind": "query",
    "text": "query GetTemplateBodyContentQuery($templateId:String!){template:confluence_template(contentTemplateId:$templateId){templateId,name,editorVersion,body{atlas_doc_format{value}}}}"
  }
};
})();

(node as any).hash = "a38b8268d20002984129f389a2681eda";

export default node;
